import { NEFI_ERROR } from 'components/NEFIForm/Utils/NEFIError';

import { KEYS_TO_GERMAN } from 'global/constants';
import {
  VALIDATION_CONDITIONS,
  always,
  isGermanyCountry,
  isLokaRefEnabled,
  never,
  onlyBAG,
} from 'global/renderingValidationConstants';

import { calculateChangedValues } from './DebFormSectionUtil';
import { ERRORS } from './Errors';

export const DEBFI_FIRST_PAGE_SECTIONS = [
  {
    id: 'companyNames',
    title: 'Firmendaten',
    whenShouldSectionRender: always,
    infoText:
      'Hier können Sie Ihre in unserem Verteiler Fachinteressenten hinterlegten Daten bearbeiten / aktualisieren.',
    fields: [
      {
        name: 'companyName1',
        fieldName: 'Firmenname / Name',
        optional: never,
        whenShouldFieldRender: always,
      },
      {
        name: 'companyName2',
        fieldName: 'Firmenname (weitere Angaben)',
        whenShouldFieldRender: always,
      },
      {
        name: 'companyName3',
        fieldName: 'Firmenname (weitere Angaben)',
        whenShouldFieldRender: always,
      },
      {
        name: 'taetigkeitsschwerpunkt',
        fieldName: 'Tätigkeitsschwerpunkt',
        type: 'comboBox',
        optional: never,
        whenShouldFieldRender: always,
      },
      {
        name: 'companyOwner',
        fieldName: 'Ansprechpartner',
        optional: {
          type: VALIDATION_CONDITIONS.NOT,
          condition: onlyBAG,
        },
        whenShouldFieldRender: onlyBAG,
      },
    ],
  },
  {
    id: 'companyAddress',
    whenShouldSectionRender: isLokaRefEnabled,
    fields: [
      {
        name: 'companyCountry',
        fieldName: 'Land',
        optional: never,
        whenShouldFieldRender: always,
      },
      {
        name: 'companyPostal',
        fieldName: 'PLZ',
        optional: never,
        whenShouldFieldRender: always,
      },
      {
        name: 'companyPostalCity',
        fieldName: 'PLZ_Ort_LokarefID',
        optional: never,
        whenShouldFieldRender: isGermanyCountry,
      },
      {
        name: 'companyCity',
        fieldName: 'Ort',
        optional: never,
        whenShouldFieldRender: always,
      },
      {
        name: 'companyRegion',
        fieldName: 'Ortsteil',
        whenShouldFieldRender: always,
      },
      {
        name: 'companyStreetId',
        fieldName: 'Straße_LokarefID',
        optional: never,
        whenShouldFieldRender: isGermanyCountry,
      },
      {
        name: 'companyStreet',
        fieldName: 'Straße',
        optional: never,
        whenShouldFieldRender: always,
      },
      {
        name: 'companyRegionId',
        fieldName: 'Ortsteil_LokarefID',
        optional: never,
        whenShouldFieldRender: isGermanyCountry,
      },
      {
        name: 'companyHouseNumber',
        fieldName: 'Hausnummer',
        optional: never,
        whenShouldFieldRender: always,
      },
      {
        name: 'companyHouseNumberAddition',
        fieldName: 'Hausnummerzusatz',
        whenShouldFieldRender: always,
      },
    ],
  },
  {
    id: 'companyStreetData',
    whenShouldSectionRender: {
      type: VALIDATION_CONDITIONS.NOT,
      condition: isLokaRefEnabled,
    },
    fields: [
      {
        name: 'companyCountry',
        fieldName: 'Land',
        optional: never,
        whenShouldFieldRender: always,
      },
      {
        name: 'companyStreet',
        fieldName: 'Straße',
        optional: never,
        whenShouldFieldRender: always,
      },
      {
        name: 'companyHouseNumber',
        fieldName: 'Hausnummer',
        optional: never,
        whenShouldFieldRender: always,
      },
    ],
  },
  {
    id: 'companyCity',
    whenShouldSectionRender: {
      type: VALIDATION_CONDITIONS.NOT,
      condition: isLokaRefEnabled,
    },
    fields: [
      {
        name: 'companyPostal',
        fieldName: 'PLZ',
        optional: never,
        whenShouldFieldRender: always,
      },
      {
        name: 'companyCity',
        fieldName: 'Ort',
        optional: never,
        whenShouldFieldRender: always,
      },
      {
        name: 'companyRegion',
        fieldName: 'Ortsteil',
        whenShouldFieldRender: always,
      },
    ],
  },
  {
    id: 'companyContacts',
    subtitle: 'Kontaktdaten',
    whenShouldSectionRender: always,
    isInstallerContact: true,
    fields: [],
  },
];

export const getDebFIFieldLabel = (fieldName) => KEYS_TO_GERMAN[fieldName] ?? fieldName;

export const checkDebFIErrors = (values, initialValues, formErrors, branchSelectionValues) => {
  const expertErrors = [];

  if (Object.keys(formErrors).length !== 0) {
    expertErrors.push(NEFI_ERROR.FORM_FIELD);
  }

  if (values.experts.length === 0) {
    expertErrors.push(NEFI_ERROR.MIN_EXPERT);
  }

  if (branchSelectionValues.isEnergyActive && branchSelectionValues.isGasActive) {
    const hasEnergyExpert = values.experts.some((expert) => expert.isExpertEnergyActive);
    const hasGasExpert = values.experts.some((expert) => expert.isExpertGasActive);
    if (!hasEnergyExpert || !hasGasExpert) {
      expertErrors.push(NEFI_ERROR.MIN_BRANCH_EXPERT);
    }
  }

  if (expertErrors.length > 0) {
    return ERRORS.DEFAULT;
  }

  const changedValues = calculateChangedValues(values, initialValues);
  if (Object.keys(changedValues).length === 0) {
    return ERRORS.NO_VALUES_CHANGED;
  }

  return '';
};
